module.exports = __webpack_public_path__ + "img/3+.3a737c9e.png";